import { HTMLAttributes } from "react";

import ThaloLogo from "@/assets/thalo-light.png";
import { cn } from "@/lib/utils";
import { InstallFlowNav } from "./install-flow-nav";

interface AuthFrameProps extends HTMLAttributes<HTMLDivElement> {
}

export function CommonFlowFrame({ className, ...props }: AuthFrameProps) {

  return (
    <div className="w-full h-screen animate-bg-pan-br">
         <div className="flex-none">

<InstallFlowNav />
</div>
      <div className="flex-1 items-center justify-center h-screen p-6 w-full">
        
          <div className={cn("h-screen w-full max-w-[350px] flex flex-col items-start", className)} {...props} >
            {props.children}
          </div>
        
      </div>
    </div>
  );
}
